function setZoomResizeListener() {
  document.addEventListener("DOMContentLoaded", function () {
    function adjustStyle() {
      const header = document.querySelector("header");
      const footer = document.querySelector("footer");
      const pageContent = document.querySelector(".page-content");
      const zoomLevel = window.outerWidth / window.innerWidth;
      const aboveZoomThreashold =
        zoomLevel > 2 &&
        window.innerWidth !== window.outerWidth &&
        window.innerWidth < 600 &&
        window.matchMedia("(pointer: fine)").matches &&
        window.innerHeight < 500;

      if (aboveZoomThreashold) {
        header.style.position = "relative";
        footer.style.position = "relative";
        if (pageContent) {
          pageContent.style.paddingTop = "70px";
        }
      } else {
        // Nollställ styles när villkoren inte är uppfyllda
        header?.style.removeProperty("position");
        footer?.style.removeProperty("position");
        footer?.style.removeProperty("paddingTop");
      }
    }

    adjustStyle();

    window.addEventListener("resize", adjustStyle);
  });
}

setZoomResizeListener();
